/** Only the shape this function actually reads off an enrollment — deliberately narrower than
 * the full generated `CourseEnrollment` type so tests can pass minimal fixtures. */
interface EnrollmentWithCompletedQuizzes {
    completedItems?: Array<{__typename: string; id?: string | null} | null> | null;
}

/**
 * Picks up to `maxLookups` quiz IDs to spend the `PopQuizAttemptLookup` budget on
 * round-robin across course enrollments for variety
 */
export function selectAttemptLookupQuizIds(
    enrollments: ReadonlyArray<EnrollmentWithCompletedQuizzes | null> | undefined,
    maxLookups: number,
): string[] {
    if (!enrollments) {
        return [];
    }

    const queues: string[][] = enrollments.map((enrollment) => {
        const quizIds: string[] = [];
        for (const item of enrollment?.completedItems ?? []) {
            if (item?.__typename === 'Quiz' && item.id) {
                quizIds.push(item.id);
            }
        }
        return quizIds;
    });

    const ids: string[] = [];
    const seen = new Set<string>();
    let madeProgress = true;
    while (ids.length < maxLookups && madeProgress) {
        madeProgress = false;
        for (const queue of queues) {
            if (ids.length >= maxLookups) {
                break;
            }
            const nextId = queue.shift();
            if (nextId === undefined) {
                continue;
            }
            madeProgress = true;
            if (!seen.has(nextId)) {
                seen.add(nextId);
                ids.push(nextId);
            }
        }
    }
    return ids;
}
